import React from "react";
import { Link } from "react-router";
import { formatNumber } from "../../../lib";

export default class RewardsTableRow extends React.PureComponent {
  render() {
    const {
      eduProgramScheduleId,
      reward: { creditValueUs, id, isAvailable, maxCredits, name, typeDisplay },
    } = this.props;

    return (
      <Link
        className="courses-rewards-table-row"
        to={`/edu/${eduProgramScheduleId}/rewards/${id}`}
      >
        <p>{name}</p>
        <p>{typeDisplay}</p>
        <p>
          {maxCredits
            ? `${maxCredits} ($${formatNumber(
                creditValueUs * maxCredits,
              )} value)`
            : ""}
        </p>
        <p>{creditValueUs ? `$${formatNumber(creditValueUs)}` : ""}</p>
        <p
          className={`relative ${isAvailable ? "active" : "inactive"}`}
          style={{ paddingLeft: "16px" }}
        >
          {isAvailable ? "Active" : "Inactive"}
        </p>
      </Link>
    );
  }
}
